import { useMemo } from "react";
import { getStatusColor } from "../../../constants";
import "./StatusBadge.css";

function StatusBadge({ text, colorMode = "Client" }) {
  const displayText = useMemo(() => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  }, [text]);

  const { bgColor, textColor } = useMemo(
    () => getStatusColor(text, colorMode),
    [text, colorMode]
  );

  if (!text) return null;

  return (
    <div
      className={`fw-semibold status-badge ${bgColor} text-${textColor}`}
      data-status={text}
      title={text}
    >
      {displayText}
    </div>
  );
}

export default StatusBadge;
